<template>
  <section class="page pageHero yellow">
    <div class="container">
      <div class="img" ></div>
      <div class="hero-content">
        <h2>Error 404! File not found.</h2>
        <div><p>We couldn’t find the page you’re looking for. Try going <router-link :to="{ name: 'Home' }">home</router-link> or using <router-link :to="{ name: 'Search' }">search.</router-link></p></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'not-found'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.page
  background: #fff

.img
  background-image: url('./not-found/LST_404.jpg')
</style>



// WEBPACK FOOTER //
// NotFound.vue?5d99d865